import { render } from "./WhatsNewPage.vue?vue&type=template&id=e76a65ae"
import script from "./WhatsNewPage.vue?vue&type=script&lang=js"
export * from "./WhatsNewPage.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__